import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/personal/Dashboard';
import MonthlyDashboard from './pages/personal/MonthlyDashboard';
import IncomeTracker from './pages/personal/IncomeTracker';
import ExpenseTracker from './pages/personal/ExpenseTracker';
import BudgetPlanner from './pages/personal/BudgetPlanner';
import SavingsGoals from './pages/personal/SavingsGoals';
import SubscriptionTracker from './pages/personal/SubscriptionTracker';
import NetWorthTracker from './pages/personal/NetWorthTracker';
import Settings from './pages/Settings';
import Pricing from './pages/Pricing';
import Landing from './pages/Landing';
import AdminPanel from './pages/admin/AdminPanel';
import FinancialReports from './pages/business/FinancialReports';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />`n          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/admin" element={<AdminPanel />} />
          
          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/monthly-dashboard" element={<MonthlyDashboard />} />
              <Route path="/income-tracker" element={<IncomeTracker />} />
              <Route path="/expense-tracker" element={<ExpenseTracker />} />
              <Route path="/budget-planner" element={<BudgetPlanner />} />
              <Route path="/savings-goals" element={<SavingsGoals />} />
              <Route path="/subscriptions" element={<SubscriptionTracker />} />
              <Route path="/net-worth" element={<NetWorthTracker />} />
              <Route path="/business/financial-reports" element={<FinancialReports />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
